// extracted by mini-css-extract-plugin
export default {"navbar":"SideNavBar_navbar__bE+5U","active":"SideNavBar_active__jsYQP"};